export default "__VITE_ASSET__17a5e130__"